import React, { Component } from 'react';
import styles from '../Layout.module.css';
import { Link, Navigate } from "react-router-dom";
import axios from 'axios';
import { BaseUrl } from '../config';
import Logo from '../../assets/images/tugo-logo-light.svg';
import LoginImg from '../../assets/images/login-ico.png';
import DarkLoginImg from '../../assets/images/dark-login-ico.png';


var cartItems = localStorage.getItem("cartItems");
 
if(cartItems === null ||  cartItems.length === undefined ){
    localStorage.setItem("cartItems","[]");
}


class Header extends Component {


    constructor(props) {
        super(props);
        this.state = {
        products:[],
        loading:false,
        tempProducts:[],
        payBool:false,
        accountName:(JSON.parse(localStorage.getItem('authData'))?JSON.parse(localStorage.getItem('authData')).accountName:""),
        cartCount:0,
        cookieAccepted: localStorage.getItem('cookie_accepted'),
        settingsList: [],
        };
        //this.getProductCategories();

        // let authData = localStorage.getItem('authData');
        // let accountName = [];
        // if(authData!==null)
        // accountName = JSON.parse(authData).accountName;.

        this.getSettings();

        }

       getSettings(){

          var siteUrl =  window.location.pathname.split('/').pop();
          let URL = BaseUrl + "admin/settings";
             axios.get(URL).then(async (response) => {
                let responseData = response.data.data[0];
                if(responseData !==''){
                  this.setState({settingsList: responseData});
                  if(responseData.maintananceMode == 1){
                     localStorage.setItem("sitemaintanance", '1');

                      if(siteUrl === "categories" || siteUrl === "sitemaintanance" || siteUrl === "terms"){
                                
                       }else{
 
                        window.location.href = '/sitemaintanance';
                      }

                  }else{

                      localStorage.setItem("sitemaintanance", '0');

                       if(siteUrl === "sitemaintanance"){
                         window.location.href = '/';
                       }

                  }
               }
             }).catch((err) => {
                console.log(err);
             });
       }

        logout(e)
        {
            if(localStorage.getItem("sitemaintanance") === 1){
               
               localStorage.clear();
               window.location.href='/sitemaintanance'; 

            }else{
               localStorage.clear();
               window.location.href='/sitemaintanance'; 
            }
            
        }

        cartCount()
        {
        let cartItems = [];
        cartItems = JSON.parse(localStorage.getItem("cartItems"));
        let QtySum = 0;
        if(cartItems!==null)
        {
            cartItems.map((item)=>{
                if(item.qty>0)
                {
                    QtySum+= item.qty;
                }
                });
        }
        return QtySum;
        //this.setState({cartCount:QtySum});

        }

        cartAmount()
        {
        let cartItems = [];
        cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var cartTotal = 0;
        if(cartItems!==null)
        {
            cartItems.map((item)=>{
                if(item.qty>0)
                {
                    cartTotal += parseFloat(item.PDP_Price1) * item.qty;
                }
                });
        }
        return cartTotal;

        }

      homeRedirection(){

           if(localStorage.getItem("sitemaintanance") == 1){
               window.location.href='/sitemaintanance'; 
            }else{
               window.location.href='/'; 
            }
        }
    
    render(){  
        const queryParameters = window.location.pathname;
        var siteUrlPage =  window.location.pathname.split('/').pop();


        return(
            <>
        <header>
            <div className="sm-container">
                
                <div className={styles.headFlx}>
                    <a className={styles.logo} onClick={this.homeRedirection.bind(this)}>
                        <img src={Logo} alt="Tugo" />
                    </a>
                    <p className={styles.headTxt}>
                        Online Ordering Portal
                    </p>
                    <div className={styles.headRight}>
                        
                        <div className={styles.rgtFlx}>
                            {/* Login In Start */}
                        </div>
                        
                        {/* Login In End */}
                       <a href="tel:02195367351" className={styles.headLink}><i className="fa fa-phone" aria-hidden="true"/>
                            01295 367 351
                        </a>
                        <a href="mailto:info@tugo.co.uk" className={styles.headLink}><i className="fa fa-envelope" />
                            info@tugo.co.uk
                        </a>

                    </div>
                </div>

            </div>
        </header>
        </>
        );
    }
}
export default Header;